import { Link } from "react-router-dom";
import { fmtTime } from "@/lib/format";
import { useTexts } from "@/lib/layout";

export const Ticker = ({ items }) => {
  const t = useTexts("layout");
  return (
  <div className="border-b border-border bg-card" data-testid="live-ticker">
    <div className="wrap flex items-center h-10 gap-4">
      <span className="flex items-center gap-2 shrink-0 bg-primary text-primary-foreground px-2.5 py-1 kicker text-[10px]">
        <span className="live-dot" />
        {t.ticker_label}
      </span>
      <div className="ticker-wrap overflow-hidden flex-1">
        <div className="ticker-track flex gap-12">
          {[...items, ...items].map((it, i) => (
            <Link key={`${it.slug}-${i}`} to={`/noticia/${it.slug}`} className="text-sm whitespace-nowrap hover:text-primary transition-colors" data-testid={i < items.length ? `ticker-item-${i}` : undefined}>
              <span className="font-mono text-[11px] text-primary mr-2">{fmtTime(it.published_at)}</span>
              {it.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  </div>
  );
};
